module.exports = __webpack_public_path__ + "static/img/splash.403789e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/splash.jpg
// module id = NuAE
// module chunks = 0